// TODO: remove?
export function getSlicesKey(slices: string[]): string {
  return slices.length === 0 ? 'NO_SLICE' : [...slices].sort().join('|')
}
